import { Routes, Route } from "react-router-dom";
import UserSettings from "./User"
import OrgSettings from "./Org"
import EditOrg from "./Org/Edit"
import Reports from "./Reports"
import StudyReports from "./Reports/Studies"
import Notifications from "./User/Notifications"
import BillingSettings from "./Billing"
import Integrations from "./Integrations"

const Settings = ({ user, access, setUser, hasSchedule, hasModalitySchedule }) => {

    return (
        <Routes>
            <Route path="/user" element={<UserSettings user={user} setUser={setUser} />} />
            <Route path="/user/notifications" element={<Notifications user={user} access={access} hasSchedule={hasSchedule} hasModalitySchedule={hasModalitySchedule} />} />
            <Route path="/org" element={<OrgSettings user={user} access={access} />} />
            <Route path="/org/edit/:org?" element={<EditOrg user={user} access={access} />} />
            <Route path="/billing" element={<BillingSettings user={user} access={access} />} />
            <Route path="/integrations" element={<Integrations user={user} access={access} />} />
            <Route path="/reports/studies" element={<StudyReports user={user} />} />
            <Route path="/reports" element={<Reports user={user} />} />
        </Routes>
    )

}

export default Settings;